export default __webpack_public_path__ + "static/media/5-zodaic-signs.ef4982c5.jpg";